export default {
    path: "survey",
    meta: { label: "Q&A Configuration" },
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        meta: {
          requiresAuth: true,
        },
        component: () => import("@/views/survey/survey.vue"),
      },
      {
        path: "create",
        name:"Create Q&A",
        meta: {
          requiresAuth: true,
        },
        component: () => import("@/views/survey/createSurvey.vue"),
      },
      {
        path: "edit/:surveyId",
        name:"Edit Q&A",
        meta: {
          requiresAuth: true,
        },
        component: () => import("@/views/survey/editSurvey.vue"),
      },
    ],
  };